import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractAction from "./AbstractAction.js";

/**
 * Action providing `strikethrough`.
 */
export default class StrikeAction extends AbstractAction {
	getMarks() {
		return {
			strike: {
				toDOM: () => ["s"],
				parseDOM: [{ tag: "del" }, { tag: "s" }, { tag: "strike" }],
			},
		};
	}

	getMenuItems({ schema }) {
		return [this._makeStrikeItem(schema.marks.strike)];
	}

	_makeStrikeItem(mark) {
		return this._makeMarkItem({
			order: 26,
			title: _("Toggle strike"),
			icon: this._makeIcon({ cssClass: "fa fa-strikethrough" }),
			mark,
		});
	}
}
